//DEVELOPMENT
export let ENDPOINT = '';
const associations = {
    tma:    'https://www.towelassociation.com',
    pcma:   'https://pcma.org.pk',
    e360:   'https://www.engineering360.pk',
    kcaa:   'https://www.towelassociation.com',
    local:  'http://127.0.0.1:80/message_center_lumen/public/api',
    prgmea: 'https://www.prgmea.org',
}
// export const ENDPOINT = `${associations.e360}/message_center/v1/api`;
// export const IMAGES_PATH = "/images/";


if (process.env.NODE_ENV === "development") ENDPOINT = `${associations.local}`;
else ENDPOINT = `${URL}/message_center/v1/api`;

//PRODUCTION
export const IMAGES_PATH = "/message_center/images/";
// export const SERVER_PATH = "https://fm.paksea.com/admin"
export const SUPPORT_URL = 'http://myfalconeye.com/support/create';
export const SERVER_PATH = "https://fm.businessfuelprovider.com/admin"
